import { Component, OnInit } from '@angular/core';
import {
  delay,
  expand,
  map,
  Observable,
  of,
  shareReplay,
  startWith,
  Subject,
  switchMap,
  takeUntil,
  timer,
} from 'rxjs';
import { AccessControlData } from 'src/app/api/contracts/client';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.scss'],
})
export class AccessControlComponent implements OnInit {
  private destroy$ = new Subject<void>();

  public readonly accessControlData$: Observable<AccessControlData>;

  constructor(private readonly authService: AuthService) {
    this.accessControlData$ = this.authService.retrieveAccessControlData().pipe(
      expand((controlData) => {
        const validUntilMs = this.parseValidUntil(controlData.valid_until.date);
        const delayMs = Math.max(validUntilMs - Date.now(), 0);

        return timer(delayMs).pipe(
          switchMap(() => this.authService.retrieveAccessControlData())
        );
      }),
      shareReplay({ bufferSize: 1, refCount: true }),
      takeUntil(this.destroy$)
    );
  }

  ngOnInit() {
    return;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private parseValidUntil(value: string): number {
    // Convert to ISO
    const iso = value.replace(' ', 'T').replace(/(\.\d{3})\d+$/, '$1') + 'Z';
    return new Date(iso).getTime();
  }
}
